var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lhorloge",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.044 11.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_601",
    "data-name": "Trac\\xE9 601",
    d: "M5.522,0a5.522,5.522,0,1,0,5.522,5.522A5.522,5.522,0,0,0,5.522,0Zm0,10.124a4.6,4.6,0,1,1,4.6-4.6A4.6,4.6,0,0,1,5.522,10.124Z",
    transform: "translate(0 0)",
    fill: "#f4efe9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_602",
    "data-name": "Trac\\xE9 602",
    d: "M9.386,6a.46.46,0,0,0-.46.46V8.45l-1.551.972a.461.461,0,0,0,.489.782L9.63,9.1a.46.46,0,0,0,.216-.395V6.46A.46.46,0,0,0,9.386,6Z",
    transform: "translate(-3.864 -3.239)",
    fill: "#f4efe9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.46120e98255513cc95c43a0fbbbe4796.svg";
export { ForwardRef as ReactComponent };